import { render, staticRenderFns } from "./PackagesReceivedEditModal.vue?vue&type=template&id=1ee8ef4a&scoped=true&"
import script from "./PackagesReceivedEditModal.vue?vue&type=script&lang=js&"
export * from "./PackagesReceivedEditModal.vue?vue&type=script&lang=js&"
import style0 from "./PackagesReceivedEditModal.vue?vue&type=style&index=0&id=1ee8ef4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee8ef4a",
  null
  
)

export default component.exports